export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_04.67728fa9.jpg";